import * as React from 'react';
import LazyLoad from 'react-lazyload';
import * as url from 'url';
import getClientEnvironment from '../../../getClientEnvironment';
import { Activity } from '../types';

const config = getClientEnvironment();

/** Get the url of a map image showing the path of the activity */
const getMapboxUrlForActivity = (
    activity: Activity,
    {
        width,
        height,
        pathColor
    }: { width: number; height: number; pathColor?: string }
) => {
    const safeColor = encodeURIComponent(
        (pathColor || config.THEME_COLOR).replace(/^#/, '')
    );

    const mapboxUrl = 'https://api.mapbox.com';
    const polyline = encodeURIComponent(
        (activity && activity.summaryPolyline) || ''
    );
    const clampedWidth = width <= 478 ? 478 : 660;
    const clampedHeight = width <= 478 ? 145 : 200;

    if (!config.MAPBOX_ACCESS_TOKEN) {
        throw new Error('No mapbox access token specified in config');
    }

    const path = url.resolve(
        mapboxUrl,
        `/styles/v1/${config.MAPBOX_USERNAME}/${
            config.MAPBOX_STYLESHEET
        }/static/path-5+${safeColor}-0.5(${polyline})/auto/${clampedWidth}x${clampedHeight}`
    );

    return `${url.format(path)}?access_token=${config.MAPBOX_ACCESS_TOKEN}`;
};

const ActivityMapImage = ({
    activity,
    pathColor
}: {
    activity: Activity;
    pathColor?: string;
}) => {
    if (!activity || !activity.summaryPolyline) {
        return (
            <h6 className="mt-5 activity-list-map-placeholder">
                No map available for this activity
            </h6>
        );
    }

    const width = 660;
    const height = 200;
    const altText = `Map of activity "${activity.name || ''}"`;

    // Get the mapbox url or a placeholder image
    const imageUrl = config.MAPBOX_PLACEHOLDERS
        ? `http://via.placeholder.com/${width}x${height}`
        : getMapboxUrlForActivity(activity, { width, height, pathColor });

    return (
        <LazyLoad height={height} offset={200} once={true}>
            <img
                alt={altText}
                className="activity-map-image"
                sizes={`(max-width: 576px) 100%,${width}px`}
                src={imageUrl}
            />
        </LazyLoad>
    );
};

export default ActivityMapImage;



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityListScene/ActivityMapImage.tsx